<script>
import {nextTick} from 'vue';
export default {
  props: {
    currentProductCount: 0,
    currentTotal: 0
  },
  data() {
    return {
      container: null,
      hasStarted: false,
      config: {
        isAnswered: [],
        current: 1,
        total: 0,
        productCount: 0,
      },
      answers: [],
      points: []
    }
  },
  beforeMount() {
    for (let i = 0; i < this.currentTotal; i++) {
      this.answers[i] = 1;
    }
  },
  mounted() {
    this.container = document.querySelector('.js-vue-digital-assistance');
    this.config.productCount = this.currentProductCount;

    for (let i = 0; i < this.currentProductCount; i++) {
      this.points.push(0)
    }

    this.config.total = this.currentTotal;

    this.addEventListeners();
  },
  watch: {
    // ...
  },
  methods: {
    addEventListeners() {
      const clickableElements = this.container.querySelectorAll('.checkbox');
      clickableElements.forEach(element => {
        element.addEventListener('click', this.triggerStartDatalayer);
      });
    },
    triggerStartDatalayer: function () {
      if (!this.hasStarted) {
        console.log('form started');
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'form_start',
          form_name: 'digital-assistance - ' + this.container.closest('[data-event-topic]').dataset.eventTopic.replace(/(<([^>]+)>)/gi, ""),
          form_destination: window.location.href,
        });
        this.hasStarted = true;
      }
    },
    triggerSubmitDatalayer: function () {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'form_submit',
        form_name: 'digital-assistance - ' + this.container.closest('[data-event-topic]').dataset.eventTopic.replace(/(<([^>]+)>)/gi, ""),
        form_destination: window.location.href,
      });
    },
    open: function (event) {
      this.isOpen = true;
      this.container.scrollIntoView(true);
      this.triggerStartDatalayer();

      let target = event.target;
      let clickText = target.dataset.eventClicktext;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'nfx_event',
        event_section: target.closest('section').getAttribute('id'),
        event_modul: 'digital-assistance',
        event_element: 'textlink',
        event_thema: target.closest('[data-event-topic]').dataset.eventTopic,
        event_klicktext: clickText.replace(/(<([^>]+)>)/gi, ""),
        event_target: '',
      });
    },

    check: function () {
      if (!this.config.isAnswered.includes(this.config.current)) {
        this.triggerStartDatalayer();
        this.config.isAnswered.push(this.config.current);
        let answers = this.container.querySelectorAll('.js-question-' + this.config.current + ' .quiz-answer');

        answers.forEach((item, index) => {
          let checkbox = item.querySelector('input');
          if (checkbox.checked) {
            this.points[index]++;
          }
        });
      }

      this.config.current++;
      this.container.scrollIntoView();

      if (this.config.current > this.config.total) {
        this.triggerSubmitDatalayer();
      }
    },

    getMaxIndex() {
      let maxPoints = Math.max(...this.points);
      let maxIndices = this.points
          .map((point, index) => (point === maxPoints ? index : -1))
          .filter(index => index !== -1);

      // Falls du nur das erste Produkt mit den meisten Punkten anzeigen willst:
      return maxIndices[0];

      // Falls du alle Produkte bei einem Gleichstand anzeigen willst:
      // return maxIndices;
    }
  },
  components: {}
};
</script>
